<template>
  <div class="w-slider">
    <div class="slider-wrapper">
      <van-slider
        :min="min"
        :max="max"
        :value="Math.min(max, value)"
        @input="onSliderChange"
        bar-height="5px"
        @change="$emit('change')"
      />
      <slider-marks :min="min" :max="max" :graticule="showGraticule ? graticule : 1" />
    </div>
    <label class="value-input clearfix" v-if="showInput">
      <input
        ref="sliderInput"
        :class="{ 'focus-input': true }"
        class="float-right"
        :value="inputValue"
        @blur="onBlurHandler"
        @focus="onFocusHandler"
      />
      <!--      <van-icon name="edit" :class="{ hidden: focusFlag }" />-->
    </label>
  </div>
</template>

<script>
import SliderMarks from '@/questions/components/SliderMarks'

export default {
  name: 'WSlider',
  components: { SliderMarks },
  props: {
    value: [Number, String],
    showInput: {
      type: Boolean,
      default: false
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    graticule: {
      type: Number,
      default: 10
    },
    showGraticule: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      focusFlag: false
    }
  },
  computed: {
    inputValue() {
      return Math.min(this.max, this.value)
    }
  },
  methods: {
    onFocusHandler() {
      this.focusFlag = true
    },
    onBlurHandler(e) {
      let value = parseInt(e.target.value)

      this.focusFlag = false
      if (isNaN(value)) {
        e.target.value = 0
        this.$emit('input', 0)
        return
      }
      if (value < this.min) {
        value = this.min
      }
      if (this.max < value) {
        value = this.max
      }
      e.target.value = value
      this.$emit('input', value)
    },
    onSliderChange(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss">
.w-slider {
  position: relative;
  display: flex;

  .value-input {
    flex: 0 0 20vw;

    input {
      width: 10vw;
      border: none;
      padding: 4px 10px;
      border-radius: 2px;

      &.focus-input {
        border: 1px solid #d8d8d8;
      }
    }
  }

  .slider-wrapper {
    flex: 1;
    position: relative;

    .van-slider {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>
